// Preserve signed/private URLs. Only remove a plain public OSS resize operation.
export function previewImageUrl(source:string):string {
  const hash=source.indexOf('#'), fragment=hash<0?'':source.slice(hash), value=hash<0?source:source.slice(0,hash)
  const question=value.indexOf('?')
  if(question<0)return source
  const params=new URLSearchParams(value.slice(question+1))
  if(Array.from(params.keys()).some(key=>/signature|credential|token|security|expires/i.test(key)))return source
  const operation=params.get('x-oss-process') || ''
  if(!/^image\/resize,[^/]+$/.test(operation))return source
  params.delete('x-oss-process')
  const query=params.toString()
  return value.slice(0,question)+(query?'?'+query:'')+fragment
}
export function imageFitScale(width:number,height:number,availableWidth:number,availableHeight:number):number {
  return width>0 && height>0?Math.min(1,Math.max(1,availableWidth)/width,Math.max(1,availableHeight)/height):1
}
